<template>
  <div class="page">
    <div class="header">
      <div class="logo">
        <img class="logo-img" src="@/views/Mobile/expert/static/logo.png" />
      </div>
      <div class="div text">
        <p class="p">Hi，你好！</p>
        <p class="p">足不出户让你了解名医专家详情</p>
      </div>
      <div class="div ul">
        <div
          v-for="item of deptList"
          :key="item.id"
          @click="toggleDep(item)"
          :class="{item: true, active: item.id === id}">
          <p class="name">{{item.deptName}}</p>
        </div>
      </div>
    </div>
    <div class="container">
      <div :class="['main', main_class]">
        <div class="dept-name">
          <p class="name">
            {{deptName}}
          </p>
          <p class="description">
            {{deptDescription}}
          </p>
        </div>
        <div class="doctor-list">
          <div
            class="item"
            v-for="item of doctorList"
            :key="item.id">
            <div class="top">
              <img class="header-img" :src="item.portraitUrl.replace(/ebaiyihui/g, 'chinachdu')" alt="" srcset="">
              <div class="text">
                <p class="p">
                  <span class="name">{{item.name}}</span>
                  <span class="leave">{{item.position}}</span>
                  <span class="time-limit">从业{{item.workingYears}}</span>
                </p>
                <p class="dept_name">
                  <span class="name">{{item.hospital}}</span>
                  <span class="name">&ensp;{{item.realDepartment}}</span>
                </p>
              </div>
              <router-link tag="p" :to="{name: 'expertDetail',params: {id: item.id}}" class="button">点击了解</router-link>
            </div>
            <div class="bottom">
              擅长领域：{{item.expertiseAreas}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const main_class = new Map([
  ['神经病学', 'sjbx'],
  ['风湿免疫科', 'fsmyk'],
  ['肿瘤科', 'zlk'],
  ['呼吸与危重症学科', 'zzxk'],
  ['重症监护', 'zzjh'],
  ['腹部外科', 'fbwk']
])
import { ready, error } from './static/tool';
export default {
  name: 'list',
  data(){
    return {
      deptList: [],
      id: 1,
      doctorList: [],
      deptDescription: '',
      deptName: '',
      main_class: '', // 医生列表容器class
    }
  },
  methods: {
    async getPageData() {
      try {
        const {code, data, msg} = await this.$HTTP.GET('https://ihos.chinachdu.com/cloud/consultation/api/show/findDeptAndDoctorInfoList');
        if(code !== '1') {
          this.$toast({message: msg});
          return
        }
        this.deptList = data,
        this.id = data[0].id,
        this.deptDescription = data[0].deptDescription,
        this.deptName = data[0].deptName,
        this.doctorList = data[0].showDoctorExpertVOList,
        this.main_class = main_class.get(data[0].deptName) || 'sjbx';
      } catch (error) {
        throw error;
      }
    },
    toggleDep(data) {
      this.id = data.id,
      this.doctorList = data.showDoctorExpertVOList,
      this.deptDescription = data.deptDescription,
      this.deptName = data.deptName;
      this.main_class = main_class.get(data.deptName) || 'sjbx';
    },
  },
  created(){
    this.getPageData();
    ready();
    error();
  }
}
</script>

<style lang="less" scoped>
@import './static/index_bak.less';
</style>
